export const CONTACT = {
  email: "Sales@nkbtrader.in",
  phone: "+917900620875",
  whatsapp: "+917900620875",
  whatsappLink: "https://wa.me/917900620875",
  address: "Ground Floor 82 Vinayak Enclave Jagatpura Jaipur 302033",
  hours: "Mon – Sat · 9:00 – 19:00 IST",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Contact", to: "/contact" },
];

export const CATEGORY_META = {
  "agri-food": { name: "Agri & Food" },
  textiles: { name: "Textiles & Garments" },
  handicrafts: { name: "Handicrafts" },
  industrial: { name: "Industrial Goods" },
};

export const IMG = {
  heroPort:
    "https://images.unsplash.com/photo-1583857671904-a716bf4ee5d8?crop=entropy&cs=srgb&fm=jpg&q=85",
  portTerminal:
    "https://images.unsplash.com/photo-1718289518008-2a6e78a87488?crop=entropy&cs=srgb&fm=jpg&q=85",
  crane:
    "https://images.unsplash.com/photo-1593617761943-9099951a0769?crop=entropy&cs=srgb&fm=jpg&q=85",
  factoryPipes:
    "https://images.unsplash.com/photo-1698031610493-c19fa20dfeab?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const STATS = [
  { value: 40, suffix: "+", label: "Countries Served" },
  { value: 1200, suffix: "+", label: "Containers Shipped" },
  { value: 98, suffix: "%", label: "On-Time Delivery" },
  { value: 24, suffix: "h", label: "Quote Response Time" },
];

export const PROCESS_STEPS = [
  {
    title: "Sourcing",
    text: "Long-term farm, mill and factory partners across India's production clusters.",
  },
  {
    title: "Quality Lab",
    text: "In-house and third-party testing for purity, grade, safety and compliance.",
  },
  {
    title: "Documentation",
    text: "Phyto, fumigation, GOTS, 3.1 certs — papers prepared before the truck rolls.",
  },
  {
    title: "Container Loading",
    text: "Supervised stuffing, weight checks and seal verification at our consolidating hubs.",
  },
  {
    title: "Door-to-Door",
    text: "FOB, CIF or DDP — we manage freight, insurance and delivery to your port or warehouse.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The basmati consignments arrive exactly as the pre-shipment samples promised. Documentation is always complete before the vessel sails — procurement here is genuinely low-friction.",
    role: "Procurement Head",
    place: "Food Importer, UAE",
  },
  {
    quote:
      "We source organic cotton fabrics and finished garments through NKB. Lab reports, GOTS certificates and honest lead times — everything our compliance team needs is ready on day one.",
    role: "Managing Director",
    place: "Apparel Retail Group, Germany",
  },
  {
    quote:
      "Mixed containers of brass décor and wooden serveware, packed so well that breakage is simply not a topic in our reviews anymore. Their consolidated shipments save us real freight cost.",
    role: "Category Buyer",
    place: "Home & Living Chain, USA",
  },
];

export const FAQS = [
  {
    q: "What payment terms do you accept?",
    a: "We work with 100% Irrevocable LC at sight, 30% advance + 70% against B/L copy (TT), and for long-term partners, open account terms after credit evaluation. Banking details are shared with the proforma invoice.",
  },
  {
    q: "What are typical lead times?",
    a: "Stocked commodities like rice, spices and yarn ship within 7–14 days of order confirmation. Made-to-order items — garments, rugs, custom brass — typically take 30–60 days depending on quantity and finish.",
  },
  {
    q: "Can I get samples before committing?",
    a: "Yes. We courier product samples worldwide — samples are free for serious enquiries; you cover the courier charge. Pre-shipment samples are always matched to bulk goods.",
  },
  {
    q: "Do you support private label and custom packaging?",
    a: "Absolutely. From printed rice bags and retail-ready spice packs to branded garment labels and gift boxes for handicrafts, we produce under your brand with your artwork and barcodes.",
  },
  {
    q: "Which ports do you ship from?",
    a: "Primary gateways are Nhava Sheva (JNPT) and Mundra for west-bound cargo, and Chennai / Kattupalli for east-bound. We quote FOB, CIF and DDP to your nearest port.",
  },
];

export const REGIONS = [
  "Middle East — UAE, Saudi Arabia, Qatar",
  "North America — USA, Canada",
  "Europe — Germany, UK, Netherlands",
  "Asia Pacific — Japan, Singapore, Australia",
  "Africa — Kenya, South Africa, Egypt",
];
